import React from "react";

export const LinkButton: React.FC<{
  children: React.ReactNode;
  onClick(): void;
  disabled?: boolean;
  ariaLabel?: string;
  title?: string;
  testId?: string;
}> = ({ children, onClick, disabled, ariaLabel, title, testId }) => (
  <button
    type="button"
    className="cursor-pointer border-none bg-transparent p-0 text-left text-xs text-observe-primary enabled:hover:underline disabled:cursor-default disabled:text-disabled"
    onClick={onClick}
    disabled={disabled}
    aria-label={ariaLabel}
    title={title}
    data-testid={testId}
  >
    {children}
  </button>
);
